import React from "react";

const Input = ({ name,
  label,
  value,
  onChange,
  error,
  type = "text",
  disable =false,
  search,
  onClick,
  placeholder = "",
  onKeyPress,
  onKeyDown,
  checked, }) => {
  return (
    <div className="form-check">
    <input
      className="form-check-input"
      type="checkbox"
      id={name}
      name={name}
      checked={checked}
      onChange ={onChange}
      style={{ width: "15px", height: "15px" }}
     
    />
    <label
      className="form-check-label"
      htmlFor="flexCheckDefault"
    >
      {label}
    </label>
  </div>

  );
};

export default Input;
